<style scoped>
.visitor_infor {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.visitor_infor .checkin_information_single {
  /*height: 120px;*/
  flex: 1;
  background: white;
  /*box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
  border-radius: 6px 6px 6px 6px;
  box-sizing: border-box;*/
  padding: 15px 30px 10px 30px;
  margin: 15px;
  text-align: center;
  /*cursor: pointer;*/
}
.checkin_information_single_icon {
  width: 42px;
  /*height: 42px;*/
}
.checkin_information_single_content {
  /*display: flex;
  align-items: center;*/
  /*margin: 14px 0;*/
  /*justify-content: space-between;*/
}
.visitor_title{
  margin: 10px 0;
  display: inline-flex;
  align-items:center;;
}
.checkin_information_single_people {
  font-size: 28px;
  color: #313b5e;
  font-weight: bold;
}
.checkin_information_single_icon {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
}
</style>

<template>
  <div class="visitor_infor">
<!--    <div class="checkin_information_single" @click="handleClick(0)">
      <div class="checkin_information_single_content">
        <div class="checkin_information_single_people">{{ visitorApplyForm.waitApprove }}</div>
      </div>
      <div class="visitor_title">
        <div class="checkin_information_single_icon" style="background: #98c511;"></div>
        <span>待审核</span>
      </div>
    </div>-->
    <div class="checkin_information_single" @click="handleClick(1)">
      <div class="checkin_information_single_content">
        <div class="checkin_information_single_people" >{{ visitorApplyForm.waitVisit }}</div>
      </div>
      <div class="visitor_title">
        <div class="checkin_information_single_icon" style="background: #009dff;"></div>
        <span>待访问</span>
      </div>
    </div>
<!--    <div class="checkin_information_single" @click="handleClick(2)">
      <div class="checkin_information_single_content">
        <div class="checkin_information_single_people" >{{ visitorApplyForm.rejected }}</div>
      </div>
      <div class="visitor_title">
        <div class="checkin_information_single_icon" style="background: #ea1638;"></div>
        <span>已拒绝</span>
      </div>
    </div>-->
    <div class="checkin_information_single" @click="handleClick(3)">
      <div class="checkin_information_single_content">
        <div class="checkin_information_single_people">{{ visitorApplyForm.visiting }}</div>
      </div>
      <div class="visitor_title">
        <div class="checkin_information_single_icon" style="background: #0fa852;"></div>
        <span>访问中</span>
      </div>
    </div>
    <div class="checkin_information_single" @click="handleClick(4)">
      <div class="checkin_information_single_content">
        <div class="checkin_information_single_people">{{ visitorApplyForm.finished }}</div>
      </div>
      <div class="visitor_title">
        <div class="checkin_information_single_icon" style="background: #877c7c;"></div>
        <span>已结束</span>
      </div>
    </div>
  </div>
</template>


<script>
import {VisitorApplyApi} from '@/api/server/visitorApply';

export default {
  components: {},
  data() {
    return {
      visitorApplyForm: {
        waitApprove: 0,
        waitVisit: 0,
        rejected: 0,
        visiting: 0,
        finished: 0,
      },
    };
  },
  created() {
    this.getData();
  },
  mounted() {

  },
  methods: {
    async getData() {
      const res = await VisitorApplyApi.selectUmsVisitorApplyStatusCount();
      if (res.code == 200) {
        this.visitorApplyForm = res.data;
      }
      return res;
    },
    handleClick(status){
      // this.$router.push( {name: 'visitorApply', params: {status: status}})
    }
  }
};
</script>